import { Event } from "../../contracts";

export const mapStatistics = (x: Event) => {
    const provider = x.media &&
        x.media.find((mediaProvider) => mediaProvider.mediaType === "Stats" && mediaProvider.providerName === "BetRadarStats");
    x.statisticsEventId = provider ? provider.providerEventId : "";
    return x;
}